import { Linkable } from "@/components/blocks/Linkable";
import { useProductDetails } from "@/data/Content/ProductDetails";
import { ContentContext } from "@/data/context/content";
import { Stack, Typography } from "@mui/material";
import { FC, useContext, useMemo } from "react";
import { BrandAndSeriesLinksSX } from "./styles/addToCartStack";
import { useLocalization } from "@/data/Localization";
import { useSettings } from "@/data/Settings";

type URLFromAttribute = {
    label?: string;
    href?: string;
}

export const BrandAndSeriesLink: FC = () => {
    
	const { productAttrValues } = useContext(ContentContext) as ReturnType<typeof useProductDetails>;

    const { settings } = useSettings();
    const attributeURL: URLFromAttribute | null = useMemo(() => {
        const {
            BrandFacets,
            BrandsURLKeyword,
            BrandAndSerie,
            BrandAndSerieURLKeyword,
            FiguresURLKeyword,
        } = productAttrValues;

        const prioritizedUrls: URLFromAttribute[] = [
            { label: FiguresURLKeyword , href: FiguresURLKeyword },                 // priority 1
            { label: BrandAndSerie, href: BrandAndSerieURLKeyword },     // priority 2
            { label: BrandFacets, href: BrandsURLKeyword },                   // priority 3
        ];

        return (prioritizedUrls.find(
                ({ label, href }) => Boolean(label?.trim()) && Boolean(href?.trim())
            ) ?? null);
    }, [productAttrValues]);

    const productDetailNLS = useLocalization("productDetail");
    const figureMappings = [
			settings.userData.FiguresURLMappings1,
			settings.userData.FiguresURLMappings2,
			settings.userData.FiguresURLMappings3,
			settings.userData.FiguresURLMappings4,
			settings.userData.FiguresURLMappings5
		].filter(Boolean).join(',');
        
    const figuresLabel = attributeURL && productAttrValues.FiguresURLKeyword ? figureMappings.split(",").find(item => item.startsWith(attributeURL.href+":"))?.split(":")[1]:'';     

    const linkLabel = figuresLabel ? figuresLabel : attributeURL?.label;

    return attributeURL && linkLabel ? (
        <Linkable
            href={`/${attributeURL.href}`}
            sx={BrandAndSeriesLinksSX}
        >
            <Stack direction="row">
                <Typography>{productDetailNLS.MoreOf.t()}&nbsp;</Typography>
                <Typography sx={{ textDecoration: 'underline' }}>
                    {linkLabel}
                </Typography>
            </Stack>
        </Linkable>
    ) : null;
}